// borrowed heavily from here https://www.cssscript.com/creating-responsive-equal-height-blocks-with-vanilla-javascript/

const sameHeights = function(nodeList) {
  const elems = [].slice.call(nodeList);

  const tallest = Math.max(...elems.map(function(elem, index) {
    elem.style.minHeight = ''; // clean first
    return elem.offsetHeight;
  }));

  elems.forEach(function(elem, index, arr) {
    elem.style.minHeight = tallest + 'px';
  });
};

const equalise = function(items) {
  items.forEach((item) => {
    const childSelector = '.item';
    const els = item.querySelectorAll(childSelector);

    sameHeights(els);
  });
};


export default function equaliser(selector = '.equalise') {
  const items = document.querySelectorAll(selector);

  equalise(items);

  let resized = true;
  let timeout = null;

  const refresh = function() {
    if (resized) {
      requestAnimationFrame(function() {
        equalise(items);
      });
    }
    clearTimeout(timeout);
    timeout = setTimeout( refresh, 100);
    resized = false;
  };

  window.addEventListener('resize', function() {
    resized = true;
  });

  refresh();

  window.addEventListener('load', function() {
    if (typeof(Event) === 'function') {
      // modern browsers
      window.dispatchEvent(new Event('resize'));
    } else {
      // for IE and other old browsers
      // causes deprecation warning on modern browsers
      const evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    }
  });

  if (typeof(Event) === 'function') {
    // modern browsers
    window.dispatchEvent(new Event('resize'));
  } else {
    // for IE and other old browsers
    // causes deprecation warning on modern browsers
    const evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }
}
